export default "__VITE_ASSET__DbF2l5E1__"